import React, {Component} from 'react'
import { withStyles } from 'material-ui/styles'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import {styles} from '../styles'

class PrivacyComponent extends Component {
    render() {
        return(
            <div style={{width: '100%'}}>
                <Paper  style={{width: '70%', margin: 'auto', marginTop: '16px', padding: '16px'}} className={this.props.classes.paper} elevation={6}>
                    <Typography variant="headline" >
                        mycareer.AI Privacy Policy 
                    </Typography>
                    <br/>
                    <Typography variant="subheading" >
                    Information that is gathered from visitors  
                    </Typography>
                    <Typography variant="caption" component='p'>
                    In common with other websites, log files are stored on the web server saving details such as the visitor's IP address, browser type, referring page and time of visit. 
                    </Typography>
                    <Typography variant="caption" component='p'>
                    Cookies may be used to remember visitor preferences when interacting with the website. 
                    </Typography>
                    <Typography variant="caption" component='p'>
                    Where registration is required, the visitor's email, first name, last name and a username will be stored on the server. Students or others taking our tests through our system, or entering the mycareer.AI system through a third-party partner, may be required to provide additional contact information to us such as school, phone number, address as well as a transcript and/or other educational documents. 
                    </Typography>
                    <br/>

                    <Typography variant="subheading" >
                    How the Information is used   
                    </Typography>
                    <Typography variant="caption" component='p'>
                    The information is used to enhance the visitor's experience when using the website to display personalized content and possibly advertising.
                    </Typography>
                    <Typography variant="caption" component='p'>
                    E-mail addresses will not be sold, rented or leased to 3rd parties without the permission of the user. The mycareer.AI service does match students with their potential majors/departments/universities.
                    </Typography>
                    <Typography variant="caption" component='p'>
                    By taking our tests, you are giving consent to mycareer.AI and partnered universities to view your assessment scores (if an assessment has been completed in our system). Additional consent is needed from you before those scores can be shared beyond the entities you have already given consent to when applying and/or taking the mycareer.AI assessment. Consent that you give to third-party partners (job boards, applicant tracking systems, etc.) with regards to information stored on their servers or access granted may entitle that third-party to data stored on mycareer.AI servers. The most common case is an application through external career finder sites/applications that use mycareer.AI algorithm. These external sites/applications have their own policies regarding privacy and terms of use. By agreeing to use the mycareer.AI Service through one of these third-parties, you also agree to allow said third-party access to your mycareer.AI data.
                    </Typography>
                    <Typography variant="caption" component='p'>
                    E-mail may be sent to inform you of news of our services or offers by us or our affiliates as well as for support purposes. 
                    </Typography>
                    <br/>

                    <Typography variant="subheading" >
                    Visitor Options   
                    </Typography>
                    <Typography variant="caption" component='p'>
                    If you have subscribed to one of our services, you may unsubscribe by following the instructions which are included in emails that you receive.
                    </Typography>
                    <Typography variant="caption" component='p'>
                    You may be able to block cookies via your browser settings but this may prevent you from access to certain features of the website. 
                    </Typography>
                    <br/>

                    <Typography variant="subheading" >
                    Cookies    
                    </Typography>
                    <Typography variant="caption" component='p'>
                    Cookies are small digital signature files that are stored by your web browser that allow your preferences to be recorded when visiting the website. Also they may be used to track your return visits to the website. 
                    </Typography>
                    <Typography variant="caption" component='p'>
                    3rd party advertising companies may also use cookies for tracking purposes. 
                    </Typography>



                </Paper>
            </div>
        )
    }
}

export default withStyles(styles)(PrivacyComponent)


// WEBPACK FOOTER //
// ./src/main/PrivacyComponent.js